// extracted by mini-css-extract-plugin
export var childrenContainer = "_51-0";
export var virtualScrollArea = "_51-1";